import React, { Component } from 'react'
import BillingAccountCard from 'features/Billing/BillingAccountCard'

export default class BillingList extends Component {
  componentWillMount() {
    const { getBillingAccounts } = this.props
    getBillingAccounts()
  }
  render() {
    const { billingAccounts } = this.props
    return (
      <div>
        {billingAccounts.map(billingAccount => (
          <BillingAccountCard key={billingAccount.ban} billingAccount={billingAccount} />
        ))}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Billing/BillingList/BillingList.jsx